const rawData = `
"4617000000"="1"="4617000000"="35.037125060961"="126.71357508766"="전라남도 나주시"="나주시"="jeollanamdo najusi"="najusi",
"4617025000"="1"="4617025000"="35.050285371914"="126.8429884139"="전라남도 나주시 남평읍"="남평읍"="jeollanamdo najusi nampyeongeup"="nampyeongeup",
"4617031000"="1"="4617031000"="34.91466624418"="126.73526027206"="전라남도 나주시 세지면"="세지면"="jeollanamdo najusi sejimyeon"="sejimyeon",
"4617032000"="1"="4617032000"="34.966940702806"="126.68962347195"="전라남도 나주시 왕곡면"="왕곡면"="jeollanamdo najusi wanggokmyeon"="wanggokmyeon",
"4617033000"="1"="4617033000"="34.914323536807"="126.65186718706"="전라남도 나주시 반남면"="반남면"="jeollanamdo najusi bannammyeon"="bannammyeon",
"4617034000"="1"="4617034000"="34.961033507491"="126.5632212325"="전라남도 나주시 공산면"="공산면"="jeollanamdo najusi gongsanmyeon"="gongsanmyeon",
"4617035000"="1"="4617035000"="34.950480399265"="126.5546527766"="전라남도 나주시 동강면"="동강면"="jeollanamdo najusi donggangmyeon"="donggangmyeon",
"4617036000"="1"="4617036000"="35.008956426315"="126.67227816832"="전라남도 나주시 다시면"="다시면"="jeollanamdo najusi dasimyeon"="dasimyeon",
"4617037000"="1"="4617037000"="35.097570245222"="126.64602561919"="전라남도 나주시 문평면"="문평면"="jeollanamdo najusi munpyeongmyeon"="munpyeongmyeon",
"4617038000"="1"="4617038000"="35.107067552932"="126.72306930454"="전라남도 나주시 노안면"="노안면"="jeollanamdo najusi noanmyeon"="noanmyeon",
"4617039000"="1"="4617039000"="35.020904463464"="126.76201006639"="전라남도 나주시 금천면"="금천면"="jeollanamdo najusi geumcheonmyeon"="geumcheonmyeon",
"4617040000"="1"="4617040000"="35.047016804395"="126.80634007933"="전라남도 나주시 산포면"="산포면"="jeollanamdo najusi sanpomyeon"="sanpomyeon",
"4617042000"="1"="4617042000"="34.962469415532"="126.83563045945"="전라남도 나주시 다도면"="다도면"="jeollanamdo najusi dadomyeon"="dadomyeon",
"4617043000"="1"="4617043000"="34.953145982996"="126.8096866247"="전라남도 나주시 봉황면"="봉황면"="jeollanamdo najusi bongwhangmyeon"="bongwhangmyeon",
"4617051000"="1"="4617051000"="35.018598204468"="126.73262221927"="전라남도 나주시 송월동"="송월동"="jeollanamdo najusi songwoldong"="songwoldong",
"4617052000"="1"="4617052000"="35.020725262983"="126.7065927231"="전라남도 나주시 영강동"="영강동"="jeollanamdo najusi yeonggangdong"="yeonggangdong",
"4617054000"="1"="4617054000"="35.022515193663"="126.71980851605"="전라남도 나주시 금남동"="금남동"="jeollanamdo najusi geumnamdong"="geumnamdong",
"4617055000"="1"="4617055000"="35.036746092294"="126.71665770263"="전라남도 나주시 성북동"="성북동"="jeollanamdo najusi seongbukdong"="seongbukdong",
"4617058000"="1"="4617058000"="35.000510923055"="126.71752269389"="전라남도 나주시 영산동"="영산동"="jeollanamdo najusi yeongsandong"="yeongsandong",
"4617060000"="1"="4617060000"="34.999345351239"="126.71786851938"="전라남도 나주시 이창동"="이창동"="jeollanamdo najusi ichangdong"="ichangdong",
"4617062000"="1"="4617062000"="35.031136928628"="126.78143616095"="전라남도 나주시 빛가람동"="빛가람동"="jeollanamdo najusi bitgaramdong"="bitgaramdong",
`;
// 데이터 구조 정의
interface RegionData {
    code: string;
    parentCode: string;
    fullCode: string;
    lat: number;
    lng: number;
    fullName: string;
    name: string;
    engFullName: string;
    engName: string;
}

// 데이터 저장소
const regions: RegionData[] = [];
const nameToCode: Record<string, string> = {};
const codeToName: Record<string, string> = {};
const codeToRegion: Record<string, RegionData> = {};

// 데이터 파싱 및 매핑
rawData
    .trim()
    .split(",")
    .forEach((line) => {
        if (!line.trim()) return;

        // 문자열에서 모든 값 추출
        const values = line.match(/"([^"]+)"/g)?.map((v) => v.replace(/"/g, ""));

        if (values && values.length >= 9) {
            const region: RegionData = {
                code: values[0],
                parentCode: values[1],
                fullCode: values[2],
                lat: parseFloat(values[3]),
                lng: parseFloat(values[4]),
                fullName: values[5],
                name: values[6],
                engFullName: values[7],
                engName: values[8],
            };

            regions.push(region);
            nameToCode[region.name] = region.code;
            nameToCode[region.fullName] = region.code;
            nameToCode[region.engName] = region.code;
            nameToCode[region.engFullName] = region.code;

            codeToName[region.code] = region.name;
            codeToRegion[region.code] = region;
        }
    });

// 기본 검색 함수
const searchByName = (name: string): string => {
    return nameToCode[name] || "코드 없음";
};

const searchByCode = (code: string): string => {
    return codeToName[code] || "이름 없음";
};

// 추가 함수들
// 특정 지역의 모든 정보 반환
const getRegionByCode = (code: string): RegionData | null => {
    return codeToRegion[code] || null;
};

// 특정 지역명으로 모든 정보 반환
const getRegionByName = (name: string): RegionData | null => {
    const code = searchByName(name);
    return code !== "코드 없음" ? codeToRegion[code] : null;
};

// 상위 지역에 속한 모든 하위 지역 찾기
const findChildRegions = (parentCode: string): RegionData[] => {
    return regions.filter((region) => region.parentCode === parentCode);
};

// 특정 좌표와 가장 가까운 지역 찾기
const findNearestRegion = (lat: number, lng: number): RegionData | null => {
    if (regions.length === 0) return null;

    let nearest = regions[0];
    let minDistance = calculateDistance(lat, lng, nearest.lat, nearest.lng);

    for (let i = 1; i < regions.length; i++) {
        const region = regions[i];
        const distance = calculateDistance(lat, lng, region.lat, region.lng);

        if (distance < minDistance) {
            minDistance = distance;
            nearest = region;
        }
    }

    return nearest;
};

// 두 좌표 사이의 거리 계산 (하버사인 공식)
const calculateDistance = (
    lat1: number,
    lng1: number,
    lat2: number,
    lng2: number
): number => {
    const R = 6371; // 지구 반경 (km)
    const dLat = toRadians(lat2 - lat1);
    const dLng = toRadians(lng2 - lng1);

    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRadians(lat1)) *
        Math.cos(toRadians(lat2)) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
};

const toRadians = (degrees: number): number => {
    return degrees * (Math.PI / 180);
};

// 특정 문자열로 지역 검색 (부분 일치)
const searchRegionsByPartialName = (partialName: string): RegionData[] => {
    const lowerPartialName = partialName.toLowerCase();
    return regions.filter(
        (region) =>
            region.name.toLowerCase().includes(lowerPartialName) ||
            region.fullName.toLowerCase().includes(lowerPartialName) ||
            region.engName.toLowerCase().includes(lowerPartialName) ||
            region.engFullName.toLowerCase().includes(lowerPartialName)
    );
};

export {
    searchByName,
    searchByCode,
    getRegionByCode,
    getRegionByName,
    findChildRegions,
    findNearestRegion,
    searchRegionsByPartialName,
    regions,
};
